module.exports = __webpack_public_path__ + "static/media/All.23442913.svg";